/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div :class="({first: cardIndex === 1,last: cardIndex === 2})" class="card"><div class="card-left"><div class="card-addr"><div class="start-addr">{{ flattenTicketInfos.from_station_name }}</div><es-icon name="arrow-switch-right" color="#666666" class="icon"/><div class="end-addr">{{ flattenTicketInfos.to_station_name }}</div><div>{{ flattenTicketInfos.train_code }}</div><div v-for="(iconItem, index) in (iconArr)" :key="iconItem.index" class="icon-arr"><mpx-image :src="(iconItem[1])" class="icon-img" v-if="(flattenTicketInfos[iconItem[0]]===1||flattenTicketInfos[iconItem[0]]===2)"/></div></div><div class="card-time card-inform">{{ tickets12306 ? item.start_time_format : flattenTicketInfos.start_time }}出发</div><div class="passenger_info" v-if="(flattenTicketInfos.passenger_info)">乘客信息: {{ flattenTicketInfos.passenger_info }}</div></div><div class="card-right" v-if="(!flattenTicketInfos.union_journey)"><hl-text :text="(flattenTicketInfos.status_name || pub.getTrainStatusValue(flattenTicketInfos))" :color="(flattenTicketInfos.status_color)" :hlColor="(flattenTicketInfos.status_color)" class="card-status"/><div class="order-num" v-if="(flattenTicketInfos.order_number && ispre)">订单号：{{ item.order_number }}</div></div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mb25b7030"}'>
.card
  display flex
  position relative
  justify-content space-between
  background-color #ffffff
  border-radius 8px
  padding 16px
  font-family PingFangSC-Regular
  &.first
    border-radius 8px 8px 0 0
    &::after
      position absolute
      content ''
      width 184%
      height 1px
      transform translateX(-50%) scale(0.5)
      bottom 0
      left 50%
      background-color #eee
  &.last 
    border-radius 0 0 8px 8px
.card-addr
  color #333
  display flex
  height 20px
  justify-content flex-start
  align-items center
  font-size 16px
  font-family PingFangSC-Medium
  font-weight 500
.card-inform
  font-size 12px
  height 16px
  line-height 16px
  font-weight 400
  color #666666
.card-time
  font-size 14px
  height 20px
  line-height 20px
  margin 8px 0 4px 0
  color #333333
  font-family PingFangSC-Medium
  font-weight 500
.card-right
  color #999999
  font-size 14px
display flex, flex-direction column, justify-content space-between, .end-addr
  margin-right 10px
.icon
  margin 4px 4px 0
  font-weight 100
  font-size 14px
.card-status
  font-size 14px
  position absolute
  right 16px
  top 16px
  font-family PingFangSC-Medium
.orange
  color #FF7F41
.blue
  color #1473FF
.gray
  color #999999
.icon-arr
  display flex
  align-items center
.icon-img
  width 24px
  height 14px
  margin-left 4px
.passenger_info
  font-size 13px
  color #666666
  height 18px
  line-height 18px
.order-num
  position absolute
  right 16px
  bottom 16px
  font-size 13px
  color #666666
  height 18px
  line-height 18px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  wxsModules.pub = require("../lib/pub.wxs")
  global.currentModuleId = "mb25b7030"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./newTrainOrderCard.mpx.js?isComponent&outputPath=components%2FnewTrainOrderCardb25b7030%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./newTrainOrderCard.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2FnewTrainOrderCardb25b7030%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mb25b7030"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/newTrainOrderCardb25b7030/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'hl-text':getComponent(require("../../../components/hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
